<template lang="pug">
   app-mapa(
      ref="mapa"
      idMapa="idMapa",
      height="65vh",
      :mapLayersConfigs="processosLayer"
      :featureLayerConfig="featureLayerConfig"
    )
</template>

<script>
import AppMapa from '@/components/AppMapa'
import layerStyles from '@/utils/layerStyles'

export default {
  components: {
    AppMapa
  },

  props: {
    dadosLabels: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      loading: true,
      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS + '/0',
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      },
      processosLayer: []
    }
  },

  created () {
    for (let i = 0; i < this.dadosLabels.length; i++) {
      if (this.dadosLabels[i + 1] && this.dadosLabels[i].area === this.dadosLabels[i + 1].area) {
        if (this.dadosLabels[i].localizacao === this.dadosLabels[i + 1].localizacao) {
          let container = this.dadosLabels[i].container ? this.dadosLabels[i].container + '<br><br>' : ''
          container += '<b>Número do Processo:</b> ' + this.dadosLabels[i].numeroProcesso
          container += '<br><b>Tipo do Processo:</b> ' + this.dadosLabels[i].tipoNome
          container += '<br><b>Status do Processo:</b> ' + this.dadosLabels[i].status
          container += '<br><b>Nome/Razão Social do Interessado:</b> ' + this.dadosLabels[i].nomeInteressado

          this.dadosLabels[i + 1].container = container
        } else {
          this.addProcesso(this.dadosLabels[i])
        }
      } else {
        this.addProcesso(this.dadosLabels[i])
      }
    }
  },

  methods: {

    addProcesso (processo) {
      let container = processo.container ? processo.container + '<br><br>' : ''
      container += '<b>Número do Processo:</b> ' + processo.numeroProcesso
      container += '<br><b>Tipo do Processo:</b> ' + processo.tipoNome
      container += '<br><b>Status do Processo:</b> ' + processo.status
      container += '<br><b>Nome/Razão Social do Interessado:</b> ' + processo.nomeInteressado

      processo.container = container

      this.processosLayer.push({
        geoJson: JSON.parse(processo.localizacao),
        popup: {container: processo.container},
        ponto: JSON.parse(processo.ponto),
        area: processo.area
      })
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/screens/produtividade/components/MapaProcessos.vue